import React from "react";
import { Link } from "react-router-dom";
import WebsiteHeading from "../../WebsiteHeading/WebsiteHeading";
import SuccessBlock from "../SuccessBlock/SuccessBlock";
import ErrorBlock from "../ErrorBlock/ErrorBlock";

const SummaryHeading = () => {
  return (
    <div>
      <span className="graphikFont text-5xl"> Summary </span>
    </div>
  );
};

const PostName = (props) => {
  const { name } = props;
  return (
    <div className="mt-4">
      <span className="graphikFont" style={{ color: "rgba(26, 26, 26, 0.45)" }}>
        {name && `Post Name: ${name}`}
      </span>
    </div>
  );
};

const Body = (props) => {
  const { state } = props.location;
  const { errors } = state;
  const successBlocks = state.completedTasks.map((task) => (
    <SuccessBlock content={task} />
  ));

  console.log(errors);
  return (
    <div className="w-full mt-12">
      <SummaryHeading />
      <WebsiteHeading {...props} />
      <PostName name={state.postName} />
      {successBlocks}
      {errors && (
        <ErrorBlock title={errors.mainTitle} subTitle={errors.subTitle} />
      )}
      <div className="checkAnotherPost rounded-lg p-5 ml-auto mr-auto mt-4 relative">
        <Link to="/" style={{ textDecoration: "none" }}>
          <span
            className="block text-left graphikFont"
            style={{ color: "rgb(0, 122, 255)" }}
          >
            Check another post
          </span>
        </Link>
      </div>
    </div>
  );
};

export default Body;
